import React, { useState } from 'react';

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'G4br13l3$!';
const IS_DEFAULT_ADMIN_PASSWORD = !process.env.REACT_APP_ADMIN_PASSWORD;

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      if (IS_DEFAULT_ADMIN_PASSWORD) {
        console.warn('[AdminLogin] Using fallback admin password from source. Set REACT_APP_ADMIN_PASSWORD to harden security.');
      }
      sessionStorage.setItem('admin_authenticated', 'true');
      onLogin();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
    }}>
      <form onSubmit={handleSubmit} style={{
        background: 'rgba(255,255,255,0.05)',
        padding: '40px',
        borderRadius: '12px',
        border: '1px solid rgba(255,255,255,0.1)',
        width: '90%',
        maxWidth: '400px'
      }}>
        <h2 style={{
          color: 'white',
          marginBottom: '30px',
          textAlign: 'center',
          fontSize: '24px',
          fontWeight: '600'
        }}>
          Admin Access
        </h2>
        
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          style={{
            width: '100%',
            padding: '15px',
            marginBottom: '20px',
            borderRadius: '8px',
            border: error ? '2px solid #ff4444' : '1px solid rgba(255,255,255,0.2)',
            background: 'rgba(255,255,255,0.05)',
            color: 'white',
            fontSize: '16px',
            outline: 'none'
          }}
          autoFocus
        />
        
        {error && (
          <p style={{
            color: '#ff4444',
            fontSize: '14px',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
            Incorrect password
          </p>
        )}
        
        <button
          type="submit"
          style={{
            width: '100%',
            padding: '15px',
            borderRadius: '8px',
            border: 'none',
            background: 'white',
            color: '#1a1a1a',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
          onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;






















